import { ChevronRight } from '@mui/icons-material';
import { Box, Card, CardHeader, Grid, Typography } from '@mui/material';
import { useAppDispatch } from '@src/app/hooks/store';
import { AssetCardDetails } from '@src/app/store/reducers/assetAllocation/types';
import { setHoldingFilters } from '@src/app/store/reducers/holdings';
import { numberFormatterDollar, percentageFormatter } from '@src/app/utils/GenericUtils';
import { holdingsUrl } from '@src/app/utils/UrlBuilder';
import { FC } from 'react';
import { useHistory } from 'react-router';

const AssetCard: FC<AssetCardDetails> = (props: AssetCardDetails): JSX.Element => {
  const history = useHistory();
  const dispatch = useAppDispatch();

  const addAssetFilteringOption = () => {
    dispatch(setHoldingFilters([{ columnField: 'assetClassName', value: props.assetClass.name, operatorValue: 'equals' }]));
  };

  const navigateToHoldings = () => {
    addAssetFilteringOption();
    history.push(holdingsUrl());
  };

  return (
    <Grid item onClick={navigateToHoldings} sx={{ ':hover': { cursor: 'pointer' } }}>
      <Card
        elevation={0}
        sx={{
          border: '1px solid #D7D7D7',
          borderRadius: '10px',
          boxShadow: '0px 0px 8px 0px #00000036',
        }}
      >
        <CardHeader
          action={<ChevronRight fontSize="medium" sx={{ color: '#D7D6D6' }} />}
          title={
            <Box display="flex" gap={2} alignItems="center">
              <Box width={21} height={21} sx={{ backgroundColor: props.color, borderRadius: '32px' }}></Box>
              <Typography fontWeight={500} fontSize={14}>
                {percentageFormatter(props.assetClass.percentageOfPortfolio || 0)}
              </Typography>
              <Typography fontWeight={500} fontSize={14} flex={1}>
                {props.assetClass.name}
              </Typography>
              <Typography fontWeight={400}>{numberFormatterDollar(props.assetClass.value)}</Typography>
            </Box>
          }
        />
      </Card>
    </Grid>
  );
};

export default AssetCard;
